<template>
  <judgement-deeds-inquiry> </judgement-deeds-inquiry>
</template>

<script>
import JudgementDeedsInquiry from '../components/judgement-deeds-inquiry/index.vue';

export default {
  components: {
    JudgementDeedsInquiry,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>
